module.exports = __webpack_public_path__ + "03eedc7f78b90b26632423f0b14ad690.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/mongolian-house-empty.png
// module id = 2846
// module chunks = 0